// eslint-disable-next-line no-restricted-imports
import { H5 } from 'dripsy';

export default H5;
